import { Component, OnDestroy, OnInit } from "@angular/core"
import { DomSanitizer } from "@angular/platform-browser"

declare var window: any

/*
Duplicated EmbedComponent to allow embedding smaller sections from the old site in the page.
TODO: if we going on this route, the EmbedComponent/Route should use this
 */

@Component({
    selector: "app-embed-min",
    templateUrl: "./embed-min.component.html",
    styleUrls: ["./embed-min.component.scss"],
})
export class EmbedMinComponent implements OnInit, OnDestroy {
    /*
    Scrolling=no is required because on some pages the scroll bars are displayed for 1px even if the content
    height does not need it.
     */
    public embedLocation = null
    private intervalInstance

    constructor(private sanitizer: DomSanitizer) {
        const parsedURL = new URL(window.location.href)
        parsedURL.searchParams.append("embed", "1")
        this.embedLocation = sanitizer.bypassSecurityTrustResourceUrl(parsedURL.href)
    }

    public ngOnInit() {
        this.detectModalInIframe()
    }

    public ngOnDestroy() {
        window.clearInterval(this.intervalInstance)
    }

    private detectModalInIframe() {
        let scrolled = false
        let openedModal = []
        this.intervalInstance = setInterval(() => {
            const iframe: any = document.querySelector("#asset-content")
            if (!iframe || !iframe.contentDocument) {
                return true
            }
            const modals = Array.from(iframe.contentDocument.querySelectorAll(".modal"))
            if (modals.length) {
                openedModal = modals.filter((modal: any) => {
                    if (window.getComputedStyle(modal).display !== "none") {
                        if (!openedModal.length) {
                            const modalDialog: any = modal.querySelector(".modal-dialog")
                            if (modalDialog) {
                                document.body.scrollTop = modalDialog.offsetTop // For Safari
                                document.documentElement.scrollTop = modalDialog.offsetTop
                                scrolled = false
                            }
                        }
                        return true
                    }
                })
            }
            // used to scroll on the bottom of the page if the drawer is opened.
            if (!openedModal.length) {
                const bottomStickyDrawer = iframe.contentDocument.querySelector(
                    "#bottomStickyDrawer"
                )
                if (bottomStickyDrawer && bottomStickyDrawer.classList.contains("open")) {
                    if (!scrolled) {
                        document.body.scrollTop = document.body.scrollHeight // For Safari
                        document.documentElement.scrollTop = document.body.scrollHeight
                        scrolled = true
                    }
                } else {
                    scrolled = false
                }
            }
        }, 300)
    }
}
